<template>
    <span v-if="index <= 9" class="w-full flex rounded-md my-2 drop-shadow-xl text-2xl font-bold text-white text-center"
        :class="[
            index % 2 === 0 && type!=='team' ? 'bg-slate-800' :
            index % 2 !== 0 && type!=='team' ? 'bg-slate-700' :
            type==='team' ? getTeamColour(bet.team) : '']">

        <span class="p-2 inline-block" :class="[type === 'global' ? 'w-1/4' : 'w-1/5']">
            <div class="flex items-center h-10">
                <img v-if="index<3" class="w-12 h-fit mx-auto" :src="asset('images/racingleague/placements/' + (parseInt(index)+1) + '.png')" />
                <p v-else class="w-full text-3xl">
                    {{ parseInt(index)+1 }}
                </p>
            </div>
        </span>

        <span v-if="type !== 'jockey' || type == 'team'"  class="p-2 inline-block" :class="[type === 'global' ? 'w-2/4' : 'w-3/5']">
            <div class="flex items-center">
                <div class="inline-flex relative w-fit">
                    <div class="shrink-0 h-10 w-10 mr-2">
                        <div class="shrink-0 h-10 w-10">
                            <img v-if="type === 'global'" class="rounded-full h-10 w-10 object-cover" :src="bet.profile_photo_url" />
                            <img v-else-if="type === 'local'" class="rounded-full h-10 w-10 object-cover" :src="bet.user.profile_photo_url" />
                            <img v-else-if="type === 'team'" class="h-11 w-11 object-fit" :src="asset(getTeamImage(bet.team))" />
                        </div>
                    </div>
                </div>
                <div class="ml-4">
                    <p v-if="type === 'global' || type === 'local'  || type == 'team'" class="text-ellipsis max-w-4">
                        {{ bet.jockey || bet.username || bet.user?.username || bet.team }}
                    </p>
                </div>
            </div>
        </span>

        <span v-if="type === 'jockey'" class="p-2 inline-block w-3/5">
            <div class="flex items-center">
                <div class="inline-flex relative w-fit">
                    <div class="shrink-0 h-10 w-fit mr-2">
                        <div class="shrink-0 h-10">
                            <img class="h-10 w-14 object-fit" :src="bet.silk_image_path" />
                        </div>
                    </div>
                </div>
                <div class="ml-4">
                    <p class="text-ellipsis max-w-4">
                        {{ bet.jockey  }}
                    </p>

                </div>
            </div>
        </span>

        <span class="p-2 inline-block" :class="[type === 'global' ? 'w-1/4' : 'w-1/5']">
            <div class="flex items-center h-10">

                <p class="w-full">
                    {{ bet.lifetime_points || bet.points || '0' }}
                </p>
            </div>
        </span>

        <span v-if="type === 'local' || type === 'team'" class="p-2 inline-block" :class="[type === 'global' ? 'w-1/4' : 'w-1/5']">
            <div class="flex items-center h-10">
                <img v-if="bet.multiplier || bet.is_boosted" class="w-16 h-fit mx-auto" :src="asset('images/racingleague/joker.png')" /> 
                <img v-else class="w-10 h-fit mx-auto opacity-70" :src="asset('images/racingleague/missing-card.png')" />
            </div>
        </span>
    </span>
</template>
  
<script>
 
 import {asset} from "vue";
 export default {
    props: {
      bet: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
      },
      type: {
        type: Text
      }
    },

    setup(props) {

        // Switch to return the correct image for the team value
        const getTeamImage = (team) => {
            switch (team) {
                case 'Ireland':
                    return ('images/racingleague/rl-ireland.svg');
                case 'The East':
                    return ('images/racingleague/rl-east.svg');
                case 'London & The South':
                    return ('images/racingleague/rl-london.svg');
                case 'The North':
                    return ('images/racingleague/rl-north.svg');
                case 'Wales & The West':
                    return ('images/racingleague/rl-wales.svg');
                case 'Yorkshire':
                    return ('images/racingleague/rl-yorkshire.svg');
                case 'Scotland':
                    return ('images/racingleague/rl-scotland.svg');
                default:
                    return ('images/racingleague/missing-card.png');
            }
        }

                // Switch to return the correct image for the team value
        const getTeamColour = (team) => {
            switch (team) {
                case 'Ireland':
                    return ('bg-rl-ireland/70');
                case 'The East':
                    return ("bg-rl-east/70");
                case 'London & The South':
                    return ("bg-rl-london/70");
                case 'The North':
                    return ("bg-[#1b2335] bg-opacity-70");
                case 'Wales & The West':
                    return ("bg-rl-wales/70");
                case 'Yorkshire':
                    return ("bg-rl-yorkshire/70");
                case 'Scotland':
                    return ("bg-rl-scotland/70");
                default:
                    return ('bg-grey-700');
            }
        }

        return {
            getTeamImage,
            getTeamColour
        }
    }
}
  </script>
